import { blob } from "stream/consumers";

export function convertToBase64(buffer: Buffer) {
  var binary = "";
  var bytes = new Uint8Array(buffer);
  bytes.forEach((bit) => {
    binary += String.fromCharCode(bit);
  });

  return window.btoa(binary);
}

export function createTemporaryURL(buffer: Buffer) {
  const bytes = new Uint8Array(buffer)
  const file = new Blob([bytes], {type: 'application/pdf'})

  const fileURL = URL.createObjectURL(file);

  return fileURL;
}
